import React, { useEffect } from "react";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import {Util} from "@xt/xtbase";
const {getOrigin} = Util;
import AiCopy from "@/components/Pages/aicopy";

export default function PageIndex(props) {
  useEffect(()=>{
  },[]);
  return (
    <>
      <Layout isShowFoot={false} bottomBarHideTop>
        <AiCopy />
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/aicopy";
  const props = {resolvedUrl};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}

